import React from 'react'
import { KibButtonNew } from '@chewy/kib-controls-react'
import { KibDeleteFillIcon } from '@chewy/kib-icons-react'
import { IconButton, TableCell } from '@mui/material'
import classNames from 'classnames'

import {
  CalculatorIcon,
  DeclineIcon,
} from '~/components/elements/Icons/generated'

import '@chewy/kib-controls-styles/dist/styles/kib-button-new.css'
import styles from './FinanceItemActionsCellBody.module.scss'

export interface FinanceItemActionsCellBodyProps {
  disabled?: boolean
  onCalculatorClick?: () => void
  onDeclineClick?: () => void
  onDeleteClick?: () => void
  showCalculatorButton?: boolean
  showDeclineButton?: boolean
  showDeleteButton?: boolean
  tableCellClassName?: string
  tableCellWithBorder?: string
}

const FinanceItemActionsCellBody = ({
  disabled = false,
  showCalculatorButton = true,
  showDeclineButton = true,
  showDeleteButton = true,
  tableCellClassName,
  tableCellWithBorder,
  onCalculatorClick,
  onDeclineClick,
  onDeleteClick,
}: FinanceItemActionsCellBodyProps) => (
  <TableCell
    align="center"
    className={classNames(
      tableCellClassName,
      tableCellWithBorder,
      styles.actionsCell,
    )}
  >
    <div className={styles.buttonContainer}>
      {showDeleteButton && (
        <KibButtonNew
          iconOnly
          aria-label="Delete"
          className={classNames(styles.iconButton, styles.deleteIcon)}
          icon={<KibDeleteFillIcon />}
          size="medium"
          onClick={onDeleteClick}
        />
      )}
      {showDeclineButton && (
        <IconButton
          aria-label="Decline"
          className={styles.declineIcon}
          disabled={disabled}
          size="medium"
          onClick={onDeclineClick}
        >
          <DeclineIcon fontSize="medium" />
        </IconButton>
      )}
      {showCalculatorButton && (
        <IconButton
          aria-label="Calculator"
          className={styles.calculatorIcon}
          disabled={disabled}
          size="medium"
          onClick={onCalculatorClick}
        >
          <CalculatorIcon fontSize="medium" />
        </IconButton>
      )}
    </div>
  </TableCell>
)

export default FinanceItemActionsCellBody
